import { MDBTable, MDBTableBody } from "mdbreact";
import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

function FarmerProfileModal({ modal, toggleCriteria }) {
  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggleCriteria}
        style={{ maxWidth: "800px" }}
        centered
      >
        <ModalHeader toggle={toggleCriteria}>
          <h5 style={{ fontWeight: "bold" }}> Farmer Profile Criteria</h5>
        </ModalHeader>
        <ModalBody>
          <table className="table table-bordered">
            <MDBTableBody>
              <tr>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Item
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Criteria
                </th>
                <th style={{ fontSize: "1rem", backgroundColor: "#f6fbfd" }}>
                  Score
                </th>
              </tr>
              <tr>
                <td>Gender</td>
                <td>
                  <tr>Male</tr>
                  <tr>Female</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>3</tr>
                </td>
              </tr>
              <tr>
                <td>Age</td>
                <td>
                  <tr>{"< 24 Years"}</tr>
                  <tr>{"< 32 Years"}</tr>
                  <tr>{"< 40 Years"}</tr>
                  <tr>{"< 50 Years"}</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  <tr>3</tr>
                  <tr>4</tr>
                </td>
              </tr>
              <tr>
                <td>Civil Status</td>
                <td>
                  <tr>Single</tr>
                  <tr>Married</tr>
                  <tr>Divorced/Widow</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>
              <tr>
                <td>No. of family members</td>
                <td>
                  <tr>{"< 2 Persons"}</tr>
                  <tr>{"<= 5 Persons"}</tr>
                  <tr>{"<= 6 Persons"}</tr>
                  <tr>{"<= 8 Persons"}</tr>
                </td>
                <td>
                  <tr>3</tr>
                  <tr>4</tr>
                  <tr>3</tr>
                  <tr>2</tr>
                </td>
              </tr>
              <tr>
                <td>Education</td>
                <td>
                  <tr>Primary</tr>
                  <tr>Secondary</tr>
                  <tr>High School/Technical</tr>
                  <tr>University/College</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  <tr>3</tr>
                  <tr>4</tr>
                </td>
              </tr>
              <tr>
                <td>House Ownership</td>
                <td>
                  <tr>Owned</tr>
                  <tr>Rent</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>
              <tr>
                <td>Alternate Income Source</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>
              <tr>
                <td>Agricultural Experience</td>
                <td>
                  <tr>{"< 1 Years"}</tr>
                  <tr>{"1-3 Years"}</tr>
                  <tr>{"3-6 Years"}</tr>
                  <tr>{"> 6 Years"}</tr>
                </td>
                <td>
                  <tr>1</tr>
                  <tr>2</tr>
                  <tr>3</tr>
                  <tr>4</tr>
                </td>
              </tr>
              <tr>
                <td>Lambardar Verification</td>
                <td>
                  <tr>Yes</tr>
                  <tr>No</tr>
                </td>
                <td>
                  <tr>4</tr>
                  <tr>2</tr>
                </td>
              </tr>
            </MDBTableBody>
          </table>
        </ModalBody>
        {/* <ModalFooter> */}
        {/* <Button color="secondary" onClick={toggleCriteria}>
            Cancel
          </Button> */}
        {/* </ModalFooter> */}
      </Modal>
    </>
  );
}

export default FarmerProfileModal;
